
      var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgWelcomeImage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 86,
  height: 80,
  viewBox: "0 0 86 80"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M62.678 22.078h13.08c3.443.01 6.231 2.846 6.242 6.347V51.1c-.01 3.5-2.799 6.336-6.241 6.347H38.003c-3.446.001-6.24-2.841-6.24-6.347V28.425c.01-3.501 2.799-6.336 6.241-6.347h17.785M39.375 45.914h35.013m-7.611-13.84h7.611",
  stroke: "var(--theme-primary, #810ea9)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 5
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1.012 2)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--theme-primary, #810ea9)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 5,
  d: "M2.225 8.053C2.237 4.09 5.467.88 9.455.867h.764c3.988.012 7.218 3.222 7.23 7.186V67.78"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--theme-primary, #810ea9)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 5,
  d: "M17.493 67.953V8.249a18.93 18.93 0 0 0-.306-3.17 5.825 5.825 0 0 0-5.33-4.212"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.225,
  cy: 14.697,
  fill: "var(--theme-primary, #810ea9)",
  fillRule: "nonzero",
  rx: 2.119,
  ry: 2.106
}), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--theme-primary, #810ea9)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 5,
  d: "M38.68 75.139h34.38c3.987-.012 7.217-3.222 7.229-7.186H32.717c-.012 3.972-3.255 7.186-7.252 7.186h-.764c-3.988-.012-7.218-3.222-7.23-7.186M9.826.867h49.582a5.826 5.826 0 0 1 5.33 4.212c.2 1.045.303 2.106.305 3.17"
})))));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"86\" height=\"80\" viewBox=\"0 0 86 80\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <g>\r\n            <g>\r\n                <g stroke=\"var(--theme-primary, #810ea9)\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"5\">\r\n                    <g>\r\n                        <path d=\"M30.915.538h13.08c3.443.01 6.231 2.846 6.242 6.347V29.56c-.01 3.5-2.799 6.336-6.241 6.347H6.24C2.794 35.908 0 33.066 0 29.56V6.885C.01 3.384 2.799.549 6.241.538h17.785M7.612 24.374L42.625 24.374M35.014 10.534L42.625 10.534\" transform=\"translate(-147 -339) translate(148.012 341) translate(30.751 19.54)\"/>\r\n                    </g>\r\n                </g>\r\n                <g transform=\"translate(-147 -339) translate(148.012 341)\">\r\n                    <path stroke=\"var(--theme-primary, #810ea9)\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"5\" d=\"M2.225 8.053C2.237 4.09 5.467.88 9.455.867h.764c3.988.012 7.218 3.222 7.23 7.186V67.78\"/>\r\n                    <path stroke=\"var(--theme-primary, #810ea9)\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"5\" d=\"M17.493 67.953V8.249c-.013-1.064-.115-2.124-.306-3.17-.682-2.396-2.827-4.091-5.33-4.212\"/>\r\n                    <ellipse cx=\"2.225\" cy=\"14.697\" fill=\"var(--theme-primary, #810ea9)\" fill-rule=\"nonzero\" rx=\"2.119\" ry=\"2.106\"/>\r\n                    <path stroke=\"var(--theme-primary, #810ea9)\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"5\" d=\"M38.68 75.139h34.38c3.987-.012 7.217-3.222 7.229-7.186H32.717c-.012 3.972-3.255 7.186-7.252 7.186h-.764c-3.988-.012-7.218-3.222-7.23-7.186M9.826.867h49.582c2.502.12 4.647 1.816 5.33 4.212.2 1.045.303 2.106.305 3.17\"/>\r\n                </g>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/welcome-image.40c8065f249d4aa034e87eadafd1a04f.svg"),
        {
          React: SvgWelcomeImage,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      